/** @format */

import React, { useRef } from "react";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import GalleryItem from "./GalleryItem";
import Item1 from "../../assets/gallery/Item1.svg";
import Item2 from "../../assets/gallery/Item2.svg";
import Item3 from "../../assets/gallery/Item3.svg";
import Item4 from "../../assets/gallery/Item4.svg";
import Item5 from "../../assets/gallery/Item5.svg";
import Item6 from "../../assets/gallery/Item6.svg";
import Item7 from "../../assets/gallery/Item7.svg";
import Item8 from "../../assets/gallery/Item8.svg";
import Item9 from "../../assets/gallery/Item9.svg";
// import { AiFillBackward, AiFillForward } from "react-icons/ai";
import Back from "../../assets/Back.svg";
import Next from "../../assets/Next.svg";

const galleryItems = [
  {
    image: Item1,
    title: "Item1",
    order: "A",
    slide: 1,
  },
  {
    image: Item2,
    title: "Item2",
    order: "C",
    slide: 2,
  },
  {
    image: Item3,
    title: "Item3",
    order: "E",
    slide: 3,
  },

  {
    image: Item4,
    title: "Item4",
    order: "G",
    slide: 4,
  },
  {
    image: Item5,
    title: "Item5",
    order: "B",
    slide: 5,
  },
  {
    image: Item6,
    title: "Item6",
    order: "D",
    slide: 6,
  },
  {
    image: Item7,
    title: "Item7",
    order: "F",
    slide: 7,
  },
  {
    image: Item8,
    title: "Item8",
    order: "H",
    slide: 8,
  },
  {
    image: Item9,
    title: "Item9",
    order: "I",
    slide: 9,
  },
];

const DotPagination = (props: {
  centerSlideDataIndex: number;
  onClick?: any;
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: 20,
      }}
      onClick={props.onClick}
    >
      {galleryItems.map((_, index) => {
        const isCenterSlide = props.centerSlideDataIndex === index;
        return (
          <div
            style={{
              height: 15,
              width: 15,
              borderRadius: "100%",
              background: isCenterSlide ? "purple" : "none",
              border: "1px solid black",
              margin: "10px",
            }}
          />
        );
      })}
    </div>
  );
};

const GallerySection = () => {
  const ref = useRef<any>();
  const [centerSlideDataIndex, setCenterSlideDataIndex] = React.useState(0);
  const onCenterSlideDataIndexChange = (newIndex: number) => {
    setCenterSlideDataIndex(newIndex);
  };

  return (
    <>
      <div
        style={{ width: "100%" }}
        className="mt-[91px] mb-[50px] relative z-10 gallery"
      >
        <ResponsiveContainer
          carouselRef={ref}
          render={(parentWidth, carouselRef) => {
            let currentVisibleSlide = 5;
            if (parentWidth <= 992) currentVisibleSlide = 3;
            // if (parentWidth <= 340) currentVisibleSlide = 1;
            return (
              <StackedCarousel
                ref={carouselRef}
                slideComponent={GalleryItem}
                slideWidth={parentWidth < 800 ? parentWidth - 40 : 750}
                carouselWidth={parentWidth}
                data={galleryItems}
                currentVisibleSlide={currentVisibleSlide}
                maxVisibleSlide={5}
                useGrabCursor
                onActiveSlideChange={onCenterSlideDataIndexChange}
              />
            );
          }}
        />

        <img
          src={Back}
          style={{ position: "absolute", top: "40%", left: 10, zIndex: 10 }}
          // fontSize={50}
          // color="purple"
          className="cursor-pointer"
          onClick={() => {
            ref.current?.goBack();
          }}
          alt="Back"
        />
        <img
          src={Next}
          style={{
            position: "absolute",
            top: "40%",
            right: 10,
            zIndex: 50,
          }}
          alt="Next"
          // fontSize={50}
          // color="purple"
          className="cursor-pointer"
          onClick={() => {
            ref.current?.goNext(6);
          }}
        />
        <div className="flex justify-center mb-[150px] mt-[20px] space-x-8">
          <DotPagination
            centerSlideDataIndex={centerSlideDataIndex}
            // onClick={() => ref.current?.goBack(1)}
          />
        </div>
      </div>
    </>
  );
};

export default GallerySection;
